<template>
  <h2 class="pb-2 border-bottom">Terapias IM/IV & Infusões de Vitaminas</h2>
  <p>Energia, Equilíbrio e Bem-Estar de Dentro para Fora</p>
  <p>Nossas terapias intravenosas, realizadas sob supervisão médica, fornecem hidratação, nutrientes e antioxidantes diretamente no organismo para absorção mais rápida e benefícios duradouros. Cada tratamento é planejado para apoiar sua saúde, recuperação e bem-estar.</p>
  <ul>
    <li>Bem-estar & hidratação — restaura o equilíbrio com eletrólitos, vitaminas e antioxidantes para hidratação completa.</li>
    <li>Energia & performance — B12 e aminoácidos para mais energia, metabolismo ativo e recuperação pós-treino.</li>
    <li>Pele & rejuvenescimento — combinações vitamínicas para saúde da pele, cabelos e brilho natural.</li>
    <li>Metabolismo & controle de peso — infusões personalizadas com aminoácidos e vitaminas do complexo B.</li>
    <li>IV de recuperação — reidratação e reequilíbrio após fadiga, viagens ou dias de estresse.</li>
  </ul>
  <p>“Nossas terapias são personalizadas e supervisionadas — feitas para você se sentir renovado, energizado e equilibrado.”</p>
</template>

<script>
export default {
  name: 'IMIVVitaminTherapiesContentPtBR'
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
